<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 13:37:27
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-09 15:59:41
-->
<template>
  <div class="dataCollection">
    <section class="dataCollection-number">
      <div>
        <span v-if="!arrList[0]">-</span>
          <countTo v-else :startVal="0" :endVal="arrList[0]" :duration="1500"  />
          <span v-if="arrList[0]">家</span>
      </div>
      <div>领码成功企业</div>
    </section>
    <section class="dataCollection-number">
      <div>
        <span v-if="!arrList[1]">-</span>
        <countTo v-else :startVal="0" :endVal="arrList[1]" :duration="1500" />
        <span v-if="arrList[1]">次</span>
      </div>
      <div>政策发布数</div>
    </section>
    <section class="dataCollection-number">
      <div>
        <span v-if="!arrList[2]">-</span>
        <countTo v-else :startVal="0" :endVal="arrList[2]" :duration="1500" />
        <span v-if="arrList[2]">家</span>
      </div>
      <div>入驻中介机构</div>
    </section>
  </div>
</template>

<script>
import countTo from "vue-count-to"
export default {
  name: 'CockpitTitle',
  components: { countTo },
  data() {
    return {}
  },
  props: {
    arrList: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dataCollection {
  position: absolute;
  top: 15%;
  left: 2%;
  z-index: 8888;
  &-number{
    color: white;
    margin-bottom: 72px;
    &>div:nth-child(1){
      font-size: 36px;
      line-height: 47px;
      text-align: center;
      // font-family: DINAlternate-Bold;
      >span:nth-child(2){
        font-weight: normal;
        font-size: 18px;
      }
    }
    &>div:nth-child(2){
      margin-top: 15px;
      font-size: 22px;
      text-align: center;
      // font-family: YouSheBiaoTiHei;
      // box-shadow: 0px 1px 30px 0px rgba(0, 171, 255, 1);
    }
  }
}
</style>
